import { useEffect } from "react";

function MobileCallback() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const sessionId =
      params.get("sessionId") ||
      params.get("sso_session") ||
      params.get("session") ||
      params.get("customerSession");

    if (!sessionId) {
      window.location.href = "/";
      return;
    }

    fetch(`/api/app-login.php?sessionId=${encodeURIComponent(sessionId)}`)
      .then((response) => response.json())
      .then((payload) => {
        if (payload && payload.ok && payload.token) {
          const deepLink = `de.bordatlas.app://map/login?sso_session=${encodeURIComponent(payload.token)}`;
          window.location.href = deepLink;
          return;
        }

        window.location.href = "/";
      })
      .catch(() => {
        window.location.href = "/";
      });
  }, []);

  return <div>Login wird zur App weitergeleitet...</div>;
}

export default MobileCallback;